import * as Yup from 'yup';
import { Formik } from 'formik';
import React, { Fragment } from 'react';
import { ModalComponent } from 'components/layout/modals/ModalComponent';
import { JobPositionDropdown } from 'components/layout/form-fields/inputs/JobPositionDropdown';
import {
	getExternalApplicationJobId,
	getExternalApplicationJobTitle
} from '../../open-jobs/externalApplicationOptions';
import { ExternalApplicationSendEmailCheckbox } from './ExternalApplicationDecisionModal';

const ValidationSchema = Yup.object().shape({
	jobs: Yup.array().min(1).required().label('Job Position')
});

export default class ExternalApplicationAssignModal extends ModalComponent {
	getInitialValues() {
		return {
			jobs: [],
			sendEmail: Boolean(this.props.hasEmail)
		};
	}

	render() {
		return (
			<Formik
				initialValues={this.getInitialValues()}
				validationSchema={ValidationSchema}
				onSubmit={values => {
					this.saving();
					this.submit(values);
				}}>
				{formikBag =>
					this.renderModalContainer(formikBag, 'ExternalApplicationAssignModal')
				}
			</Formik>
		);
	}

	renderForm(formikBag) {
		const selectedJobs = formikBag.values.jobs || [];

		return (
			<Fragment>
				<div className="columns">
					<div className="column is-full">
						<p className="mb-4 has-text-left">
							Select the job position you want to assign this applicant to.
						</p>
						<div className="field has-text-left">
							<label className="subtitle is-7">Job Position</label>
							<div className="control">
								<JobPositionDropdown
									onValueChange={item => {
										if (!item) return;
										if (selectedJobs.some(job => job.id === item.id)) return;
										formikBag.setFieldValue('jobs', [...selectedJobs, item]);
									}}
									value={null}
									showOnlyOpenJobs
									styleVersion="ats"
								/>
							</div>
						</div>
						{selectedJobs.length > 0 ? (
							<ul className="selected-jobs-list">
								{selectedJobs.map(job => (
									<li key={job.id}>
										<span>
											{getExternalApplicationJobId(job)}{' '}
											{getExternalApplicationJobTitle(job)}
										</span>
										<button
											type="button"
											className="remove-job-btn"
											onClick={() =>
												formikBag.setFieldValue(
													'jobs',
													selectedJobs.filter(item => item.id !== job.id)
												)
											}
											aria-label="Remove job">
											<img src="/ats/icons/close-3-icon.svg" alt="" />
										</button>
									</li>
								))}
							</ul>
						) : null}
						<div className="mt-4">
							<ExternalApplicationSendEmailCheckbox
								checked={Boolean(formikBag.values.sendEmail)}
								onChange={checked =>
									formikBag.setFieldValue('sendEmail', checked)
								}
								disabled={!this.props.hasEmail || this.state.saving}
								label={
									this.props.hasEmail
										? 'Send approval email to the applicant'
										: 'No email on file, no email will be sent'
								}
							/>
						</div>
					</div>
				</div>
			</Fragment>
		);
	}

	async submit(values) {
		const jobIds = (values.jobs || []).map(job => job.id);
		const success = await this.props.onApprove?.(jobIds, {
			sendEmail: Boolean(this.props.hasEmail && values.sendEmail)
		});
		if (success) {
			this.closeWithSuccess({ status: 'success' });
			return;
		}
		this.saving(false);
	}
}
